import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { AssignListInfo } from './types';

type GetAssignListArgs = {
  porSlot: boolean;
  codViaje: number;
  armador: string;
};

type GetAssignListResponse = {
  state: number;
  value: AssignListInfo[];
};

export const getAssignList = async ({
  porSlot,
  codViaje,
  armador,
}: GetAssignListArgs): Promise<AssignListInfo[]> => {
  try {
    const res = await apiClient.post<GetAssignListResponse>(
      Endpoints.AssignList,
      {
        porSlot,
        codViaje,
        armador,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
